import styled, { css } from 'styled-components';

export const TextContainer = styled.div`
  ${({ theme: { colors, customized } }) => css`
    flex: 1 0 0;
    line-height: 20px;
    font: 14px ${customized.fonts.primary};
    color: ${colors.primaryBlack};
  `}
`;

export const LoginLink = styled.span`
  cursor: pointer;
  color: var(--dct--customized-colors-buttonsLinks);
`;
export const SocialLoginContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme: { spaces } }) => spaces[2]};
  align-self: stretch;
`;

export const SocialButtonContainer = styled.button`
  display: flex;
  width: 32px;
  height: 32px;
  padding: 0;
  justify-content: center;
  align-items: center;
  border-radius: 9999px;
  border: none;
  cursor: pointer;
  background: #f5f6f7;

  svg {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }
`;

export const CloseButton = styled.button`
  width: 20px;
  height: 20px;
  cursor: pointer;
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
